<template>
  <svg
    fill="currentColor"
    viewBox="0 0 256 256"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M128,28A100,100,0,1,0,228,128,100.1127,100.1127,0,0,0,128,28Zm0,192a92,92,0,1,1,92-92A92.10478,92.10478,0,0,1,128,220Zm8-136v92a4,4,0,0,1-8,0V91.47266l-17.78223,11.84961a4.00018,4.00018,0,0,1-4.43554-6.65821l24-15.99316A4.00031,4.00031,0,0,1,136,84Z" />
  </svg>
</template>
